export default __webpack_public_path__ + "static/media/c4.094c055e.svg";